import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import Landing from './pages/index'
import BenefitEffectiveReport from './pages/BenefitEffectiveReport/BenefitEffectiveReport'
import ReconciliationV2 from './pages/ReconciliationV2/ReconciliationV2'
import ReconciliationV2Reports from './pages/ReconciliationV2Reports/ReconciliationV2Reports'
import PaymentBulkUpload from './pages/PaymentBulkUpload'
import PaymentAssignment from './pages/PaymentAssignment/PaymentAssignment'
import PaymentAssignmentBulkClear from './pages/PaymentAssignment/PaymentAssignmentBulkClear'
import PaymentAssignmentBulkStatus from './pages/PaymentAssignment/PaymentAssignmentBulkStatus'
import PaymentAssignmentBulkAssign from './pages/PaymentAssignment/PaymentAssignmentBulkAssign'
import PaymentBatchUpdate from './pages/PaymentBatchUpdate/PaymentBatchUpdate'
import BillingProfileManagement from './pages/ClientBillingProfileManagement/ClientBillingProfileManagement'
import UserManagement from './pages/UserManagement/UserManagement'
import BulkInvoiceUpload from './pages/BulkInvoiceUpload/BulkInvoiceUpload'
import {
  BILLING_PROFILE_TAB_KEYS,
  billingProfileTabPath,
  FINANCE_PATH,
} from './constants'
import PageWrapper from 'enrollment-platform/PageWrapper'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PaymentAssignmentMetrics from './pages/PaymentAssignmentMetrics/PaymentAssignmentMetrics'
import VcnManagement from './pages/VcnManagement/VcnManagement'

const FinanceRoutes = {
  path: FINANCE_PATH,
  component: PageWrapper,
  onEnter(_nextState, replace, callback) {
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: Landing,
  },
  childRoutes: [
    {
      path: 'payment-reconciliation-v2',
      component: ReconciliationV2,
    },
    {
      path: 'payment-reconciliation-v2/reports',
      component: ReconciliationV2Reports,
    },
    {
      path: 'payment-bulk-upload',
      component: PaymentBulkUpload,
    },
    {
      path: 'payment-assignment',
      component: PaymentAssignment,
    },
    {
      path: 'payment-assignment/metrics',
      component: PaymentAssignmentMetrics,
    },
    {
      path: 'payment-assignment/bulk-clear',
      component: PaymentAssignmentBulkClear,
    },
    {
      path: 'payment-assignment/bulk-status',
      component: PaymentAssignmentBulkStatus,
    },
    {
      path: 'payment-assignment/bulk-assign',
      component: PaymentAssignmentBulkAssign,
    },
    {
      path: 'payment-batch-update',
      component: PaymentBatchUpdate,
    },
    {
      path: 'billing-profiles',
      component: BillingProfileManagement,
    },
    {
      path: 'billing-profiles/funding-managers',
      component: UserManagement,
    },
    {
      path: 'invoice-management',
      onEnter(_nextState, replace) {
        replace(`${FINANCE_PATH}/invoice-management/generation`)
      },
    },
    {
      path: 'invoice-management/:mode',
      component: BulkInvoiceUpload,
    },
    {
      path: 'invoice-management/:mode/invoices/:invoiceId',
      component: BulkInvoiceUpload,
    },
    {
      path: 'users',
      onEnter(_nextState, replace) {
        replace(
          billingProfileTabPath(BILLING_PROFILE_TAB_KEYS.FUNDING_MANAGERS)
        )
      },
    },
    {
      path: 'benefit-effective-report',
      component: BenefitEffectiveReport,
    },
    {
      path: 'vcn-management',
      component: VcnManagement,
    },
  ],
}

export default FinanceRoutes
